import React from 'react';
import {Button, message, Modal} from "antd";

import Html5QrcodePlugin from "./index";
import {getCurrentDomainAndSubdomain, isUrlMatchingDomain} from "../../util/methods";

function QrScan({
                    openCamera,
                    toggleOpenCamera,
                    handleScan,
                    checkQrAlreadyUsed,
                    isOnlyRead,
                    setOldQr,
                    getAssetByQr,
                    handleScanInIphone,
                    onLoad,
                    disableQRCode,
                    renderCamera,
                    qrCodeRef
                }) {


    const onNewScanResult = (text, result) => {
        // console.log(text, result);
        let isOldQr = false;
        let isOk = isUrlMatchingDomain(text, 'theassetpro.com', 'qrcode');
        // console.log(`IS OK : ${isOk}`)
        if (!isOk) {
            const {domain, subdomain} = getCurrentDomainAndSubdomain();
            // console.log('D ', domain);
            // console.log('S ', subdomain);
            isOk = text.includes('assetCode='); // && text.includes(`${subdomain}.${domain}`) ;
            if (domain === 'localhost')
                isOk = true;

            // console.log(`IS OK : ${isOk}`)
            if (isOk) {
                isOldQr = true;
                setOldQr(isOk); // set as old QR
            }
        }
        // console.log(`IS OLD : ${isOldQr}`)
        let qrId = '';
        try {
            if (!isOldQr) {
                const parsedUrl = new URL(text);
                const pathParts = parsedUrl.pathname.split('/');
                qrId = pathParts[3]; // qr id
                //call action to bring asset code from qr id
                if (isOnlyRead) // only in ast
                    getAssetByQr(qrId);
            } else {
                if (text && text.includes('assetCode=')) {
                    qrId = text.split('assetCode=').pop().split('&')[0]; // asset code
                }
            }
            if (text && isOk && qrId) {
                //check already used
                if (!isOnlyRead) // only read i.e. in AST no use check required
                    checkQrAlreadyUsed(qrId);
                handleScan(qrId);
            } else {
                message.error('Invalid QR!');
            }

        } catch (e) {
            console.error(e);
        }
        // console.log(qrUsed);
    }

    const onScanError = (error) => {
        console.log(error)
    }

    return (
        <div>
            <Modal
                title="Scan QR Code"
                visible={openCamera}
                onCancel={toggleOpenCamera}
                centered
                footer={<Button onClick={toggleOpenCamera}>Close</Button>}
            >
                {
                    <Html5QrcodePlugin
                        fps={10}
                        qrbox={250}
                        disableFlip={false}
                        qrCodeSuccessCallback={onNewScanResult}
                        // qrCodeErrorCallback={onScanError}
                    />
                }
            </Modal>
        </div>
    );
}

export default QrScan;
